import React from 'react';
import './HeroSection.css';

// Obrazy z public/ - preloadowane w index.html
const studentHeroImage = '/images/student-redhead.png';
const boyHeroImage = '/images/student-boy-nobg.png';

const HeroSection: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-image-background">
        <img
          src="/images/backgrounds/math-blackboard.jpg"
          alt="Mathematical formulas on blackboard"
          className="hero-bg-image"
          loading="eager"
                  />
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-container">
        {/* Kontener na postacie - osobna warstwa (desktop) */}
        <div className="hero-students-container">
          <div className="hero-student-left">
            <img
              src={boyHeroImage}
              alt="Zadowolony uczeń Sigma Study"
              className="hero-boy-image"
              loading="eager"
                          />
          </div>
          <div className="hero-student-right">
            <img
              src={studentHeroImage}
              alt="Zadowolona uczennica Sigma Study"
              className="hero-girl-image"
              loading="eager"
                          />
          </div>
        </div>

        {/* Zdjęcie dziewczyny na mobile - widoczne tylko na małych ekranach */}
        <div className="hero-mobile-image">
          <img
            src={studentHeroImage}
            alt="Zadowolona uczennica Sigma Study"
            className="hero-mobile-girl"
            loading="eager"
                      />
        </div>

        {/* Baner z treścią - na wierzchu */}
        <div className="hero-content">
          <h1 className="hero-title">
            ucz się od tych dla których <span className="highlight">matematyka jest pasją</span>
          </h1>
          <p className="hero-subtitle">
            Odkryj, że nauka matematyki może sprawiać frajdę! Dołącz do zadowolonych uczniów i rodziców, którzy wybrali Sigma Study.
          </p>
          <ul className="hero-features">
            <li className="feature">
              <span className="feature-check" aria-hidden="true"></span>
              <span>Wygodne zajęcia online</span>
            </li>
            <li className="feature">
              <span className="feature-check" aria-hidden="true"></span>
              <span>Indywidualne podejście</span>
            </li>
            <li className="feature">
              <span className="feature-check" aria-hidden="true"></span>
              <span>Gwarancja poprawy ocen</span>
            </li>
          </ul>
          <div className="hero-buttons">
            <button onClick={scrollToContact} className="primary-button">
              🎯 ROZPOCZNIJ DZIŚ - ZAPISZ SIĘ NA ZAJĘCIA!
            </button>
            <button onClick={() => document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' })} className="secondary-button">
              Zobacz opinie uczniów
            </button>
          </div>
        </div>
      </div>
      {/* Gradient przejściowy do następnej sekcji */}
      <div className="hero-transition"></div>
    </section>
  );
};

export default HeroSection;
